import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing } from '@metro-ui/tokens/js';
import { fontStack } from '../utils/fontStack';
import { Label } from '../Label';
import { ToggleComponent, } from './components/ToggleComponent';
import { ToggleLabel } from './components/ToggleLabel';
export var Toggle = styled(React.forwardRef(function (_a, ref) {
    var id = _a.id, className = _a.className, children = _a.children, value = _a.value, name = _a.name, onChange = _a.onChange, errorMessage = _a.errorMessage, rest = __rest(_a, ["id", "className", "children", "value", "name", "onChange", "errorMessage"]);
    var toggleLabelId = id + "-label";
    return (React.createElement(Label, { className: className, htmlFor: id },
        React.createElement(ToggleLabel, { id: toggleLabelId, errorMessage: errorMessage }, children),
        React.createElement(ToggleComponent, __assign({ "aria-labelledby": toggleLabelId, ref: ref }, __assign({ id: id, name: name, className: className, value: value, onChange: onChange }, rest)))));
}))(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    position: relative;\n    min-height: ", ";\n    display: flex;\n    justify-content: space-between;\n  "], ["\n    ", "\n    position: relative;\n    min-height: ", ";\n    display: flex;\n    justify-content: space-between;\n  "])), fontStack, spacing['x-large']); });
Toggle.propTypes = {
    id: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    size: PropTypes.oneOf(['large', 'small']),
    variant: PropTypes.oneOf(['decision', 'danger']),
    isDisabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    hasError: PropTypes.bool,
    className: PropTypes.string,
    // not in ToggleComponent:
    children: PropTypes.node.isRequired,
};
var templateObject_1;
//# sourceMappingURL=Toggle.js.map